export function validateRequest(value) {
  const validate = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const format0 = new RegExp(
      '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$',
      'i',
    )
    const pattern0 = new RegExp('^.*$', 'u')
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const pattern1 = new RegExp('^[a-z]+([A-Z][a-z]+)*[A-Z]?$', 'u')
    const format1 = new RegExp('^0x[a-f0-9]*$', 'i')
    const format2 = new RegExp('^0x[a-f0-9]{40}$', 'i')
    const pattern2 = new RegExp('^[a-z]+$', 'u')
    const format3 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const unique = (array) => {
      if (array.length < 2) return true
      if (array.length === 2) return !deepEqual(array[0], array[1])
      const objects = []
      const primitives = array.length > 20 ? new Set() : null
      let primitivesCount = 0
      let pos = 0
      for (const item of array) {
        if (typeof item === 'object') {
          objects.push(item)
        } else if (primitives) {
          primitives.add(item)
          if (primitives.size !== ++primitivesCount) return false
        } else {
          if (array.indexOf(item, pos + 1) !== -1) return false
        }
        pos++
      }
      for (let i = 1; i < objects.length; i++)
        for (let j = 0; j < i; j++)
          if (deepEqual(objects[i], objects[j])) return false
      return true
    }
    const deepEqual = (obj, obj2) => {
      if (obj === obj2) return true
      if (!obj || !obj2 || typeof obj !== typeof obj2) return false
      if (obj !== obj2 && typeof obj !== 'object') return false

      const proto = Object.getPrototypeOf(obj)
      if (proto !== Object.getPrototypeOf(obj2)) return false

      if (proto === Array.prototype) {
        if (!Array.isArray(obj) || !Array.isArray(obj2)) return false
        if (obj.length !== obj2.length) return false
        return obj.every((x, i) => deepEqual(x, obj2[i]))
      } else if (proto === Object.prototype) {
        const [keys, keys2] = [Object.keys(obj), Object.keys(obj2)]
        if (keys.length !== keys2.length) return false
        const keyset2 = new Set([...keys, ...keys2])
        return (
          keyset2.size === keys.length &&
          keys.every((key) => deepEqual(obj[key], obj2[key]))
        )
      }
      return false
    }
    const ref1 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length > 3) {
        validate.errors = [
          { keywordLocation: '#/maxItems', instanceLocation: '#' },
        ]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      for (let i = 0; i < data.length; i++) {
        if (i in data && hasOwn(data, i)) {
          const sub2 = (() => {
            if (!(typeof data[i] === 'boolean')) return false
            return true
          })()
          const sub3 = (() => {
            if (
              !(
                typeof data[i] === 'object' &&
                data[i] &&
                !Array.isArray(data[i])
              )
            )
              return false
            for (const key0 of Object.keys(data[i])) {
              if (key0.length > 20 && stringLength(key0) > 20) return false
              if (!pattern1.test(key0)) return false
            }
            for (const key1 of Object.keys(data[i])) {
              if (data[i][key1] !== undefined) {
                const sub4 = (() => {
                  if (!(typeof data[i][key1] === 'string')) return false
                  if (!format1.test(data[i][key1])) return false
                  return true
                })()
                const sub5 = (() => {
                  if (
                    !(
                      Array.isArray(data[i][key1]) && data[i][key1].length === 0
                    )
                  )
                    return false
                  return true
                })()
                const sub6 = (() => {
                  const err0 = validate.errors
                  const res0 = validate(data[i][key1])
                  const suberr0 = validate.errors
                  validate.errors = err0
                  if (!res0) return false
                  return true
                })()
                const sub7 = (() => {
                  if (!(typeof data[i][key1] === 'string')) return false
                  if (!format2.test(data[i][key1])) return false
                  return true
                })()
                if (!(sub4 || sub5 || sub6 || sub7)) return false
              }
            }
            return true
          })()
          const sub8 = (() => {
            if (!(typeof data[i] === 'string')) return false
            if (!format1.test(data[i])) return false
            return true
          })()
          const sub9 = (() => {
            if (!(typeof data[i] === 'string')) return false
            if (!pattern2.test(data[i])) return false
            return true
          })()
          const sub10 = (() => {
            if (!(data[i] === null)) return false
            return true
          })()
          const sub11 = (() => {
            if (!Array.isArray(data[i])) return false
            if (data[i].length < 1) return false
            for (let j = 0; j < data[i].length; j++) {
              if (j in data[i] && hasOwn(data[i], j)) {
                const sub12 = (() => {
                  if (!(typeof data[i][j] === 'number')) return false
                  return true
                })()
                const sub13 = (() => {
                  if (!(typeof data[i][j] === 'string')) return false
                  if (data[i][j].length > 100 && stringLength(data[i][j]) > 100)
                    return false
                  if (!format3.test(data[i][j])) return false
                  return true
                })()
                if (!(sub12 || sub13)) return false
              }
            }
            return true
          })()
          const sub14 = (() => {
            if (!(Array.isArray(data[i]) && data[i].length === 0)) return false
            return true
          })()
          if (!(sub2 || sub3 || sub8 || sub9 || sub10 || sub11 || sub14)) {
            validate.errors = [
              { keywordLocation: '#/items/anyOf', instanceLocation: '#/' + i },
            ]
            return false
          }
        }
      }
      if (!unique(data)) {
        validate.errors = [
          { keywordLocation: '#/uniqueItems', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const format4 = new RegExp('^0x[0-9a-f]+$', 'i')
    const ref2 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!format4.test(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/format', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref4 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('from' in data && hasOwn(data, 'from'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/from' },
        ]
        return false
      }
      if ('chainId' in data && hasOwn(data, 'chainId')) {
        let passes1 = 0
        const sub15 = (() => {
          if (!(typeof data.chainId === 'string')) return false
          if (!format4.test(data.chainId)) return false
          return true
        })()
        if (sub15) passes1++
        const sub16 = (() => {
          if (!(typeof data.chainId === 'number')) return false
          return true
        })()
        if (sub16) passes1++
        if (passes1 !== 1) {
          validate.errors = [
            {
              keywordLocation: '#/properties/chainId/oneOf',
              instanceLocation: '#/chainId',
            },
          ]
          return false
        }
      }
      if (!(typeof data.from === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/from/type',
            instanceLocation: '#/from',
          },
        ]
        return false
      }
      if (!format2.test(data.from)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/from/format',
            instanceLocation: '#/from',
          },
        ]
        return false
      }
      if ('to' in data && hasOwn(data, 'to')) {
        if (!(typeof data.to === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/to/type',
              instanceLocation: '#/to',
            },
          ]
          return false
        }
        if (!format2.test(data.to)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/to/format',
              instanceLocation: '#/to',
            },
          ]
          return false
        }
      }
      if ('gas' in data && hasOwn(data, 'gas')) {
        if (!(typeof data.gas === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/gas/type',
              instanceLocation: '#/gas',
            },
          ]
          return false
        }
        if (!format4.test(data.gas)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/gas/format',
              instanceLocation: '#/gas',
            },
          ]
          return false
        }
      }
      if ('gasPrice' in data && hasOwn(data, 'gasPrice')) {
        let passes2 = 0
        const sub17 = (() => {
          if (!(typeof data.gasPrice === 'string')) return false
          if (!format4.test(data.gasPrice)) return false
          return true
        })()
        if (sub17) passes2++
        const sub18 = (() => {
          if (!(data.gasPrice === null)) return false
          return true
        })()
        if (sub18) passes2++
        if (passes2 !== 1) {
          validate.errors = [
            {
              keywordLocation: '#/properties/gasPrice/oneOf',
              instanceLocation: '#/gasPrice',
            },
          ]
          return false
        }
      }
      if ('value' in data && hasOwn(data, 'value')) {
        if (!(typeof data.value === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/value/type',
              instanceLocation: '#/value',
            },
          ]
          return false
        }
        if (!format1.test(data.value)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/value/format',
              instanceLocation: '#/value',
            },
          ]
          return false
        }
      }
      if ('data' in data && hasOwn(data, 'data')) {
        if (!(typeof data.data === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/data/type',
              instanceLocation: '#/data',
            },
          ]
          return false
        }
        if (!format1.test(data.data)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/data/format',
              instanceLocation: '#/data',
            },
          ]
          return false
        }
      }
      if (
        'maxPriorityFeePerGas' in data &&
        hasOwn(data, 'maxPriorityFeePerGas')
      ) {
        let passes3 = 0
        const sub19 = (() => {
          if (!(typeof data.maxPriorityFeePerGas === 'string')) return false
          if (!format1.test(data.maxPriorityFeePerGas)) return false
          return true
        })()
        if (sub19) passes3++
        const sub20 = (() => {
          if (!(data.maxPriorityFeePerGas === null)) return false
          return true
        })()
        if (sub20) passes3++
        if (passes3 !== 1) {
          validate.errors = [
            {
              keywordLocation: '#/properties/maxPriorityFeePerGas/oneOf',
              instanceLocation: '#/maxPriorityFeePerGas',
            },
          ]
          return false
        }
      }
      if ('maxFeePerGas' in data && hasOwn(data, 'maxFeePerGas')) {
        let passes4 = 0
        const sub21 = (() => {
          if (!(typeof data.maxFeePerGas === 'string')) return false
          if (!format1.test(data.maxFeePerGas)) return false
          return true
        })()
        if (sub21) passes4++
        const sub22 = (() => {
          if (!(data.maxFeePerGas === null)) return false
          return true
        })()
        if (sub22) passes4++
        if (passes4 !== 1) {
          validate.errors = [
            {
              keywordLocation: '#/properties/maxFeePerGas/oneOf',
              instanceLocation: '#/maxFeePerGas',
            },
          ]
          return false
        }
      }
      for (const key2 of Object.keys(data)) {
        if (
          key2 !== 'chainId' &&
          key2 !== 'from' &&
          key2 !== 'to' &&
          key2 !== 'gas' &&
          key2 !== 'gasPrice' &&
          key2 !== 'value' &&
          key2 !== 'data' &&
          key2 !== 'maxPriorityFeePerGas' &&
          key2 !== 'maxFeePerGas'
        )
          delete data[key2]
      }
      return true
    }
    const ref3 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err23 = validate.errors
        const res23 = ref4(data[0])
        const suberr23 = ref4.errors
        validate.errors = err23
        if (!res23) {
          validate.errors = [errorMerge(suberr23[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref5 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!format2.test(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/format', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        if (!(typeof data[1] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/1/type', instanceLocation: '#/1' },
          ]
          return false
        }
        if (!format4.test(data[1])) {
          validate.errors = [
            { keywordLocation: '#/1/format', instanceLocation: '#/1' },
          ]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref6 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err26 = validate.errors
        const res26 = ref4(data[0])
        const suberr26 = ref4.errors
        validate.errors = err26
        if (!res26) {
          validate.errors = [errorMerge(suberr26[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref7 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!format2.test(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/format', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        if (!(typeof data[1] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/1/type', instanceLocation: '#/1' },
          ]
          return false
        }
        if (data[1].length > 10000 && stringLength(data[1]) > 10000) {
          validate.errors = [
            { keywordLocation: '#/1/maxLength', instanceLocation: '#/1' },
          ]
          return false
        }
        if (!format3.test(data[1])) {
          validate.errors = [
            { keywordLocation: '#/1/format', instanceLocation: '#/1' },
          ]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const format5 = new RegExp('^(?![\\s_])[\\s\\w!?.,/()[\\]-]+$', '')
    const ref9 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      for (let k = 0; k < data.length; k++) {
        if (k in data && hasOwn(data, k)) {
          if (
            !(typeof data[k] === 'object' && data[k] && !Array.isArray(data[k]))
          ) {
            validate.errors = [
              { keywordLocation: '#/items/type', instanceLocation: '#/' + k },
            ]
            return false
          }
          if (!('name' in data[k] && hasOwn(data[k], 'name'))) {
            validate.errors = [
              {
                keywordLocation: '#/items/required',
                instanceLocation: '#/' + k + '/name',
              },
            ]
            return false
          }
          if (!('type' in data[k] && hasOwn(data[k], 'type'))) {
            validate.errors = [
              {
                keywordLocation: '#/items/required',
                instanceLocation: '#/' + k + '/type',
              },
            ]
            return false
          }
          if (!('value' in data[k] && hasOwn(data[k], 'value'))) {
            validate.errors = [
              {
                keywordLocation: '#/items/required',
                instanceLocation: '#/' + k + '/value',
              },
            ]
            return false
          }
          if (!(typeof data[k].name === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/name/type',
                instanceLocation: '#/' + k + '/name',
              },
            ]
            return false
          }
          if (data[k].name.length > 50 && stringLength(data[k].name) > 50) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/name/maxLength',
                instanceLocation: '#/' + k + '/name',
              },
            ]
            return false
          }
          if (!format5.test(data[k].name)) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/name/format',
                instanceLocation: '#/' + k + '/name',
              },
            ]
            return false
          }
          if (!(typeof data[k].type === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/type/type',
                instanceLocation: '#/' + k + '/type',
              },
            ]
            return false
          }
          if (data[k].type.length > 50 && stringLength(data[k].type) > 50) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/type/maxLength',
                instanceLocation: '#/' + k + '/type',
              },
            ]
            return false
          }
          if (!format5.test(data[k].type)) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/type/format',
                instanceLocation: '#/' + k + '/type',
              },
            ]
            return false
          }
          if (!(typeof data[k].value === 'string')) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/value/type',
                instanceLocation: '#/' + k + '/value',
              },
            ]
            return false
          }
          if (
            data[k].value.length > 10000 &&
            stringLength(data[k].value) > 10000
          ) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/value/maxLength',
                instanceLocation: '#/' + k + '/value',
              },
            ]
            return false
          }
          if (!format3.test(data[k].value)) {
            validate.errors = [
              {
                keywordLocation: '#/items/properties/value/format',
                instanceLocation: '#/' + k + '/value',
              },
            ]
            return false
          }
          for (const key3 of Object.keys(data[k])) {
            if (key3 !== 'name' && key3 !== 'type' && key3 !== 'value') {
              validate.errors = [
                {
                  keywordLocation: '#/items/additionalProperties',
                  instanceLocation: '#/' + k + '/' + pointerPart(key3),
                },
              ]
              return false
            }
          }
        }
      }
      return true
    }
    const ref8 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err29 = validate.errors
        const res29 = ref9(data[0])
        const suberr29 = ref9.errors
        validate.errors = err29
        if (!res29) {
          validate.errors = [errorMerge(suberr29[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        if (!(typeof data[1] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/1/type', instanceLocation: '#/1' },
          ]
          return false
        }
        if (!format2.test(data[1])) {
          validate.errors = [
            { keywordLocation: '#/1/format', instanceLocation: '#/1' },
          ]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref10 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 2) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (!(typeof data[0] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (data[0].length > 10000 && stringLength(data[0]) > 10000) {
          validate.errors = [
            { keywordLocation: '#/0/maxLength', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!format3.test(data[0])) {
          validate.errors = [
            { keywordLocation: '#/0/format', instanceLocation: '#/0' },
          ]
          return false
        }
      }
      if (1 in data && hasOwn(data, 1)) {
        if (!(typeof data[1] === 'string')) {
          validate.errors = [
            { keywordLocation: '#/1/type', instanceLocation: '#/1' },
          ]
          return false
        }
        if (!format2.test(data[1])) {
          validate.errors = [
            { keywordLocation: '#/1/format', instanceLocation: '#/1' },
          ]
          return false
        }
      }
      if (data.length > 2) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref13 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      for (const key4 of Object.keys(data)) {
        validate.errors = [
          {
            keywordLocation: '#/additionalProperties',
            instanceLocation: '#/' + pointerPart(key4),
          },
        ]
        return false
      }
      return true
    }
    const ref12 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if ('eth_accounts' in data && hasOwn(data, 'eth_accounts')) {
        const err35 = validate.errors
        const res35 = ref13(data.eth_accounts)
        const suberr35 = ref13.errors
        validate.errors = err35
        if (!res35) {
          validate.errors = [
            errorMerge(
              suberr35[0],
              '#/properties/eth_accounts/$ref',
              '#/eth_accounts',
            ),
          ]
          return false
        }
      }
      for (const key5 of Object.keys(data)) {
        if (key5 !== 'eth_accounts') {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key5),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref11 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        const err36 = validate.errors
        const res36 = ref12(data[0])
        const suberr36 = ref12.errors
        validate.errors = err36
        if (!res36) {
          validate.errors = [errorMerge(suberr36[0], '#/0/$ref', '#/0')]
          return false
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref14 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (
          !(typeof data[0] === 'object' && data[0] && !Array.isArray(data[0]))
        ) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!('chainId' in data[0] && hasOwn(data[0], 'chainId'))) {
          validate.errors = [
            {
              keywordLocation: '#/0/required',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        if (!(typeof data[0].chainId === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainId/type',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        if (!format4.test(data[0].chainId)) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainId/format',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        for (const key6 of Object.keys(data[0])) {
          if (key6 !== 'chainId') {
            validate.errors = [
              {
                keywordLocation: '#/0/additionalProperties',
                instanceLocation: '#/' + pointerPart(key6),
              },
            ]
            return false
          }
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const format6 = new RegExp(
      "^[a-z][a-z0-9+\\-.]*:(?:\\/?\\/(?:(?:[a-z0-9\\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)\\.){3}(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+\\.[a-z0-9\\-._~!$&'()*+,;=:]+)\\]|(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)\\.){3}(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d\\d?)|(?:[a-z0-9\\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\\d*)?(?:\\/(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\\/?(?:(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\\/(?:[a-z0-9\\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?)(?:\\?(?:[a-z0-9\\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$",
      'i',
    )
    const ref15 = function validate(data) {
      validate.errors = null
      if (!Array.isArray(data)) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1) {
        validate.errors = [
          { keywordLocation: '#/minItems', instanceLocation: '#' },
        ]
        return false
      }
      if (0 in data && hasOwn(data, 0)) {
        if (
          !(typeof data[0] === 'object' && data[0] && !Array.isArray(data[0]))
        ) {
          validate.errors = [
            { keywordLocation: '#/0/type', instanceLocation: '#/0' },
          ]
          return false
        }
        if (!('chainId' in data[0] && hasOwn(data[0], 'chainId'))) {
          validate.errors = [
            {
              keywordLocation: '#/0/required',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        if (!('chainName' in data[0] && hasOwn(data[0], 'chainName'))) {
          validate.errors = [
            {
              keywordLocation: '#/0/required',
              instanceLocation: '#/0/chainName',
            },
          ]
          return false
        }
        if (!(typeof data[0].chainId === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainId/type',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        if (!format4.test(data[0].chainId)) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainId/format',
              instanceLocation: '#/0/chainId',
            },
          ]
          return false
        }
        if (!(typeof data[0].chainName === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainName/type',
              instanceLocation: '#/0/chainName',
            },
          ]
          return false
        }
        if (
          data[0].chainName.length > 50 &&
          stringLength(data[0].chainName) > 50
        ) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainName/maxLength',
              instanceLocation: '#/0/chainName',
            },
          ]
          return false
        }
        if (!format5.test(data[0].chainName)) {
          validate.errors = [
            {
              keywordLocation: '#/0/properties/chainName/format',
              instanceLocation: '#/0/chainName',
            },
          ]
          return false
        }
        if (
          'blockExplorerUrls' in data[0] &&
          hasOwn(data[0], 'blockExplorerUrls')
        ) {
          if (!Array.isArray(data[0].blockExplorerUrls)) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/blockExplorerUrls/type',
                instanceLocation: '#/0/blockExplorerUrls',
              },
            ]
            return false
          }
          if (data[0].blockExplorerUrls.length < 1) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/blockExplorerUrls/minItems',
                instanceLocation: '#/0/blockExplorerUrls',
              },
            ]
            return false
          }
          for (let l = 0; l < data[0].blockExplorerUrls.length; l++) {
            if (
              l in data[0].blockExplorerUrls &&
              hasOwn(data[0].blockExplorerUrls, l)
            ) {
              if (!(typeof data[0].blockExplorerUrls[l] === 'string')) {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/0/properties/blockExplorerUrls/items/type',
                    instanceLocation: '#/blockExplorerUrls/' + l,
                  },
                ]
                return false
              }
              if (
                data[0].blockExplorerUrls[l].length > 100 &&
                stringLength(data[0].blockExplorerUrls[l]) > 100
              ) {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/0/properties/blockExplorerUrls/items/maxLength',
                    instanceLocation: '#/blockExplorerUrls/' + l,
                  },
                ]
                return false
              }
              if (!format6.test(data[0].blockExplorerUrls[l])) {
                validate.errors = [
                  {
                    keywordLocation:
                      '#/0/properties/blockExplorerUrls/items/format',
                    instanceLocation: '#/blockExplorerUrls/' + l,
                  },
                ]
                return false
              }
            }
          }
        }
        if ('iconUrls' in data[0] && hasOwn(data[0], 'iconUrls')) {
          if (!Array.isArray(data[0].iconUrls)) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/iconUrls/type',
                instanceLocation: '#/0/iconUrls',
              },
            ]
            return false
          }
          if (data[0].iconUrls.length < 0) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/iconUrls/minItems',
                instanceLocation: '#/0/iconUrls',
              },
            ]
            return false
          }
          for (let m = 0; m < data[0].iconUrls.length; m++) {
            if (m in data[0].iconUrls && hasOwn(data[0].iconUrls, m)) {
              if (!(typeof data[0].iconUrls[m] === 'string')) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/iconUrls/items/type',
                    instanceLocation: '#/iconUrls/' + m,
                  },
                ]
                return false
              }
              if (
                data[0].iconUrls[m].length > 100 &&
                stringLength(data[0].iconUrls[m]) > 100
              ) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/iconUrls/items/maxLength',
                    instanceLocation: '#/iconUrls/' + m,
                  },
                ]
                return false
              }
              if (!format6.test(data[0].iconUrls[m])) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/iconUrls/items/format',
                    instanceLocation: '#/iconUrls/' + m,
                  },
                ]
                return false
              }
            }
          }
        }
        if ('rpcUrls' in data[0] && hasOwn(data[0], 'rpcUrls')) {
          if (!Array.isArray(data[0].rpcUrls)) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/rpcUrls/type',
                instanceLocation: '#/0/rpcUrls',
              },
            ]
            return false
          }
          if (data[0].rpcUrls.length < 1) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/rpcUrls/minItems',
                instanceLocation: '#/0/rpcUrls',
              },
            ]
            return false
          }
          for (let n = 0; n < data[0].rpcUrls.length; n++) {
            if (n in data[0].rpcUrls && hasOwn(data[0].rpcUrls, n)) {
              if (!(typeof data[0].rpcUrls[n] === 'string')) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/rpcUrls/items/type',
                    instanceLocation: '#/rpcUrls/' + n,
                  },
                ]
                return false
              }
              if (
                data[0].rpcUrls[n].length > 100 &&
                stringLength(data[0].rpcUrls[n]) > 100
              ) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/rpcUrls/items/maxLength',
                    instanceLocation: '#/rpcUrls/' + n,
                  },
                ]
                return false
              }
              if (!format6.test(data[0].rpcUrls[n])) {
                validate.errors = [
                  {
                    keywordLocation: '#/0/properties/rpcUrls/items/format',
                    instanceLocation: '#/rpcUrls/' + n,
                  },
                ]
                return false
              }
            }
          }
        }
        if ('nativeCurrency' in data[0] && hasOwn(data[0], 'nativeCurrency')) {
          if (
            !(
              typeof data[0].nativeCurrency === 'object' &&
              data[0].nativeCurrency &&
              !Array.isArray(data[0].nativeCurrency)
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/nativeCurrency/type',
                instanceLocation: '#/0/nativeCurrency',
              },
            ]
            return false
          }
          if (
            !(
              'decimals' in data[0].nativeCurrency &&
              hasOwn(data[0].nativeCurrency, 'decimals')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/nativeCurrency/required',
                instanceLocation: '#/0/nativeCurrency/decimals',
              },
            ]
            return false
          }
          if (
            !(
              'symbol' in data[0].nativeCurrency &&
              hasOwn(data[0].nativeCurrency, 'symbol')
            )
          ) {
            validate.errors = [
              {
                keywordLocation: '#/0/properties/nativeCurrency/required',
                instanceLocation: '#/0/nativeCurrency/symbol',
              },
            ]
            return false
          }
          if (!(typeof data[0].nativeCurrency.decimals === 'number')) {
            validate.errors = [
              {
                keywordLocation:
                  '#/0/properties/nativeCurrency/properties/decimals/type',
                instanceLocation: '#/0/nativeCurrency/decimals',
              },
            ]
            return false
          }
          if (
            'name' in data[0].nativeCurrency &&
            hasOwn(data[0].nativeCurrency, 'name')
          ) {
            if (!(typeof data[0].nativeCurrency.name === 'string')) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/0/properties/nativeCurrency/properties/name/type',
                  instanceLocation: '#/0/nativeCurrency/name',
                },
              ]
              return false
            }
            if (
              data[0].nativeCurrency.name.length > 50 &&
              stringLength(data[0].nativeCurrency.name) > 50
            ) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/0/properties/nativeCurrency/properties/name/maxLength',
                  instanceLocation: '#/0/nativeCurrency/name',
                },
              ]
              return false
            }
            if (!format5.test(data[0].nativeCurrency.name)) {
              validate.errors = [
                {
                  keywordLocation:
                    '#/0/properties/nativeCurrency/properties/name/format',
                  instanceLocation: '#/0/nativeCurrency/name',
                },
              ]
              return false
            }
          }
          if (!(typeof data[0].nativeCurrency.symbol === 'string')) {
            validate.errors = [
              {
                keywordLocation:
                  '#/0/properties/nativeCurrency/properties/symbol/type',
                instanceLocation: '#/0/nativeCurrency/symbol',
              },
            ]
            return false
          }
          if (
            data[0].nativeCurrency.symbol.length > 50 &&
            stringLength(data[0].nativeCurrency.symbol) > 50
          ) {
            validate.errors = [
              {
                keywordLocation:
                  '#/0/properties/nativeCurrency/properties/symbol/maxLength',
                instanceLocation: '#/0/nativeCurrency/symbol',
              },
            ]
            return false
          }
          if (!format5.test(data[0].nativeCurrency.symbol)) {
            validate.errors = [
              {
                keywordLocation:
                  '#/0/properties/nativeCurrency/properties/symbol/format',
                instanceLocation: '#/0/nativeCurrency/symbol',
              },
            ]
            return false
          }
          for (const key7 of Object.keys(data[0].nativeCurrency)) {
            if (key7 !== 'decimals' && key7 !== 'name' && key7 !== 'symbol') {
              validate.errors = [
                {
                  keywordLocation:
                    '#/0/properties/nativeCurrency/additionalProperties',
                  instanceLocation: '#/nativeCurrency/' + pointerPart(key7),
                },
              ]
              return false
            }
          }
        }
        for (const key8 of Object.keys(data[0])) {
          if (
            key8 !== 'chainId' &&
            key8 !== 'chainName' &&
            key8 !== 'blockExplorerUrls' &&
            key8 !== 'iconUrls' &&
            key8 !== 'rpcUrls' &&
            key8 !== 'nativeCurrency'
          ) {
            validate.errors = [
              {
                keywordLocation: '#/0/additionalProperties',
                instanceLocation: '#/' + pointerPart(key8),
              },
            ]
            return false
          }
        }
      }
      if (data.length > 1) {
        validate.errors = [
          { keywordLocation: '#/items', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const format7 = (input) =>
      input.length % 4 === 0 && /^[a-z0-9+/]*={0,3}$/i.test(input)
    const ref18 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'string')) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (data.length < 1 || stringLength(data) < 1) {
        validate.errors = [
          { keywordLocation: '#/minLength', instanceLocation: '#' },
        ]
        return false
      }
      if (!format7(data)) {
        validate.errors = [
          { keywordLocation: '#/format', instanceLocation: '#' },
        ]
        return false
      }
      return true
    }
    const ref17 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('address' in data && hasOwn(data, 'address'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/address' },
        ]
        return false
      }
      if (!(typeof data.address === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/address/type',
            instanceLocation: '#/address',
          },
        ]
        return false
      }
      if (!format2.test(data.address)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/address/format',
            instanceLocation: '#/address',
          },
        ]
        return false
      }
      if ('symbol' in data && hasOwn(data, 'symbol')) {
        if (!(typeof data.symbol === 'string')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/symbol/type',
              instanceLocation: '#/symbol',
            },
          ]
          return false
        }
        if (data.symbol.length > 5 && stringLength(data.symbol) > 5) {
          validate.errors = [
            {
              keywordLocation: '#/properties/symbol/maxLength',
              instanceLocation: '#/symbol',
            },
          ]
          return false
        }
        if (!format5.test(data.symbol)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/symbol/format',
              instanceLocation: '#/symbol',
            },
          ]
          return false
        }
      }
      if ('decimals' in data && hasOwn(data, 'decimals')) {
        if (!(typeof data.decimals === 'number')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/decimals/type',
              instanceLocation: '#/decimals',
            },
          ]
          return false
        }
      }
      if ('image' in data && hasOwn(data, 'image')) {
        let passes5 = 0
        const sub23 = (() => {
          if (!(typeof data.image === 'string')) return false
          if (!format6.test(data.image)) return false
          return true
        })()
        if (sub23) passes5++
        const sub24 = (() => {
          const err41 = validate.errors
          const res41 = ref18(data.image)
          const suberr41 = ref18.errors
          validate.errors = err41
          if (!res41) return false
          return true
        })()
        if (sub24) passes5++
        if (passes5 !== 1) {
          validate.errors = [
            {
              keywordLocation: '#/properties/image/oneOf',
              instanceLocation: '#/image',
            },
          ]
          return false
        }
      }
      if ('chainId' in data && hasOwn(data, 'chainId')) {
        if (!(typeof data.chainId === 'number')) {
          validate.errors = [
            {
              keywordLocation: '#/properties/chainId/type',
              instanceLocation: '#/chainId',
            },
          ]
          return false
        }
      }
      for (const key9 of Object.keys(data)) {
        if (
          key9 !== 'address' &&
          key9 !== 'symbol' &&
          key9 !== 'decimals' &&
          key9 !== 'image' &&
          key9 !== 'chainId'
        ) {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key9),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref16 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('type' in data && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!('options' in data && hasOwn(data, 'options'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/options' },
        ]
        return false
      }
      if (!(typeof data.type === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/type',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      if (data.type.length > 20 && stringLength(data.type) > 20) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/maxLength',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      if (!format5.test(data.type)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/format',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      const err42 = validate.errors
      const res42 = ref17(data.options)
      const suberr42 = ref17.errors
      validate.errors = err42
      if (!res42) {
        validate.errors = [
          errorMerge(suberr42[0], '#/properties/options/$ref', '#/options'),
        ]
        return false
      }
      for (const key10 of Object.keys(data)) {
        if (key10 !== 'type' && key10 !== 'options') {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key10),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!('jsonrpc' in data && hasOwn(data, 'jsonrpc'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/jsonrpc' },
        ]
        return false
      }
      if (!('id' in data && hasOwn(data, 'id'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/id' },
        ]
        return false
      }
      if (!('method' in data && hasOwn(data, 'method'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/method' },
        ]
        return false
      }
      if (!(data.jsonrpc === '2.0')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/jsonrpc/const',
            instanceLocation: '#/jsonrpc',
          },
        ]
        return false
      }
      let passes0 = 0
      const sub0 = (() => {
        if (!(typeof data.id === 'string')) return false
        if (!format0.test(data.id)) return false
        return true
      })()
      if (sub0) passes0++
      const sub1 = (() => {
        if (!Number.isInteger(data.id)) return false
        return true
      })()
      if (sub1) passes0++
      if (passes0 !== 1) {
        validate.errors = [
          {
            keywordLocation: '#/properties/id/oneOf',
            instanceLocation: '#/id',
          },
        ]
        return false
      }
      if (!(typeof data.method === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/type',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      if (!pattern0.test(data.method)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/method/pattern',
            instanceLocation: '#/method',
          },
        ]
        return false
      }
      switch (data.method) {
        case 'eth_isConnected':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/0/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_accounts':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/1/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_blockNumber':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/2/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_chainId':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/3/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_call':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/4/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err1 = validate.errors
          const res1 = ref1(data.params)
          const suberr1 = ref1.errors
          validate.errors = err1
          if (!res1) {
            validate.errors = [
              errorMerge(
                suberr1[0],
                '#/oneOf/4/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_coinbase':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/5/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/5/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_createAccessList':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/6/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err2 = validate.errors
          const res2 = ref1(data.params)
          const suberr2 = ref1.errors
          validate.errors = err2
          if (!res2) {
            validate.errors = [
              errorMerge(
                suberr2[0],
                '#/oneOf/6/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_estimateGas':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/7/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err3 = validate.errors
          const res3 = ref1(data.params)
          const suberr3 = ref1.errors
          validate.errors = err3
          if (!res3) {
            validate.errors = [
              errorMerge(
                suberr3[0],
                '#/oneOf/7/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_feeHistory':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/8/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err4 = validate.errors
          const res4 = ref1(data.params)
          const suberr4 = ref1.errors
          validate.errors = err4
          if (!res4) {
            validate.errors = [
              errorMerge(
                suberr4[0],
                '#/oneOf/8/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_gasPrice':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/9/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/9/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_getBalance':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/10/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err5 = validate.errors
          const res5 = ref1(data.params)
          const suberr5 = ref1.errors
          validate.errors = err5
          if (!res5) {
            validate.errors = [
              errorMerge(
                suberr5[0],
                '#/oneOf/10/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getBlockByHash':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/11/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err6 = validate.errors
          const res6 = ref1(data.params)
          const suberr6 = ref1.errors
          validate.errors = err6
          if (!res6) {
            validate.errors = [
              errorMerge(
                suberr6[0],
                '#/oneOf/11/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getBlockByNumber':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/12/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err7 = validate.errors
          const res7 = ref1(data.params)
          const suberr7 = ref1.errors
          validate.errors = err7
          if (!res7) {
            validate.errors = [
              errorMerge(
                suberr7[0],
                '#/oneOf/12/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getBlockTransactionCountByHash':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/13/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err8 = validate.errors
          const res8 = ref1(data.params)
          const suberr8 = ref1.errors
          validate.errors = err8
          if (!res8) {
            validate.errors = [
              errorMerge(
                suberr8[0],
                '#/oneOf/13/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getBlockTransactionCountByNumber':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/14/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err9 = validate.errors
          const res9 = ref1(data.params)
          const suberr9 = ref1.errors
          validate.errors = err9
          if (!res9) {
            validate.errors = [
              errorMerge(
                suberr9[0],
                '#/oneOf/14/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getCode':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/15/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err10 = validate.errors
          const res10 = ref1(data.params)
          const suberr10 = ref1.errors
          validate.errors = err10
          if (!res10) {
            validate.errors = [
              errorMerge(
                suberr10[0],
                '#/oneOf/15/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getCompilers':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/16/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/16/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_getLogs':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/17/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err11 = validate.errors
          const res11 = ref1(data.params)
          const suberr11 = ref1.errors
          validate.errors = err11
          if (!res11) {
            validate.errors = [
              errorMerge(
                suberr11[0],
                '#/oneOf/17/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getProof':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/18/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err12 = validate.errors
          const res12 = ref1(data.params)
          const suberr12 = ref1.errors
          validate.errors = err12
          if (!res12) {
            validate.errors = [
              errorMerge(
                suberr12[0],
                '#/oneOf/18/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getStorageAt':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/19/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err13 = validate.errors
          const res13 = ref1(data.params)
          const suberr13 = ref1.errors
          validate.errors = err13
          if (!res13) {
            validate.errors = [
              errorMerge(
                suberr13[0],
                '#/oneOf/19/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getTransactionByBlockHashAndIndex':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/20/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err14 = validate.errors
          const res14 = ref1(data.params)
          const suberr14 = ref1.errors
          validate.errors = err14
          if (!res14) {
            validate.errors = [
              errorMerge(
                suberr14[0],
                '#/oneOf/20/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getTransactionByBlockNumberAndIndex':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/21/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err15 = validate.errors
          const res15 = ref1(data.params)
          const suberr15 = ref1.errors
          validate.errors = err15
          if (!res15) {
            validate.errors = [
              errorMerge(
                suberr15[0],
                '#/oneOf/21/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getTransactionByHash':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/22/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err16 = validate.errors
          const res16 = ref1(data.params)
          const suberr16 = ref1.errors
          validate.errors = err16
          if (!res16) {
            validate.errors = [
              errorMerge(
                suberr16[0],
                '#/oneOf/22/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getTransactionCount':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/23/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err17 = validate.errors
          const res17 = ref1(data.params)
          const suberr17 = ref1.errors
          validate.errors = err17
          if (!res17) {
            validate.errors = [
              errorMerge(
                suberr17[0],
                '#/oneOf/23/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getTransactionReceipt':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/24/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err18 = validate.errors
          const res18 = ref1(data.params)
          const suberr18 = ref1.errors
          validate.errors = err18
          if (!res18) {
            validate.errors = [
              errorMerge(
                suberr18[0],
                '#/oneOf/24/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getUncleCountByBlockHash':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/25/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err19 = validate.errors
          const res19 = ref1(data.params)
          const suberr19 = ref1.errors
          validate.errors = err19
          if (!res19) {
            validate.errors = [
              errorMerge(
                suberr19[0],
                '#/oneOf/25/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getUncleByBlockHashAndIndex':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/26/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err20 = validate.errors
          const res20 = ref1(data.params)
          const suberr20 = ref1.errors
          validate.errors = err20
          if (!res20) {
            validate.errors = [
              errorMerge(
                suberr20[0],
                '#/oneOf/26/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getUncleByBlockNumberAndIndex':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/27/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err21 = validate.errors
          const res21 = ref1(data.params)
          const suberr21 = ref1.errors
          validate.errors = err21
          if (!res21) {
            validate.errors = [
              errorMerge(
                suberr21[0],
                '#/oneOf/27/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_getWork':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/28/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/28/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_maxPriorityFeePerGas':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/29/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/29/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_hashrate':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/30/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/30/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_pendingTransactions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/31/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/31/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_requestAccounts':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/32/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/32/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'eth_sendRawTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/33/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err22 = validate.errors
          const res22 = ref2(data.params)
          const suberr22 = ref2.errors
          validate.errors = err22
          if (!res22) {
            validate.errors = [
              errorMerge(
                suberr22[0],
                '#/oneOf/33/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_sendTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/34/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err24 = validate.errors
          const res24 = ref3(data.params)
          const suberr24 = ref3.errors
          validate.errors = err24
          if (!res24) {
            validate.errors = [
              errorMerge(
                suberr24[0],
                '#/oneOf/34/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_sign':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/35/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err25 = validate.errors
          const res25 = ref5(data.params)
          const suberr25 = ref5.errors
          validate.errors = err25
          if (!res25) {
            validate.errors = [
              errorMerge(
                suberr25[0],
                '#/oneOf/35/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_signTransaction':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/36/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err27 = validate.errors
          const res27 = ref6(data.params)
          const suberr27 = ref6.errors
          validate.errors = err27
          if (!res27) {
            validate.errors = [
              errorMerge(
                suberr27[0],
                '#/oneOf/36/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_signTypedData':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/37/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err28 = validate.errors
          const res28 = ref7(data.params)
          const suberr28 = ref7.errors
          validate.errors = err28
          if (!res28) {
            validate.errors = [
              errorMerge(
                suberr28[0],
                '#/oneOf/37/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_signTypedData_v1':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/38/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err30 = validate.errors
          const res30 = ref8(data.params)
          const suberr30 = ref8.errors
          validate.errors = err30
          if (!res30) {
            validate.errors = [
              errorMerge(
                suberr30[0],
                '#/oneOf/38/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_signTypedData_v3':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/39/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err31 = validate.errors
          const res31 = ref7(data.params)
          const suberr31 = ref7.errors
          validate.errors = err31
          if (!res31) {
            validate.errors = [
              errorMerge(
                suberr31[0],
                '#/oneOf/39/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_signTypedData_v4':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/40/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err32 = validate.errors
          const res32 = ref7(data.params)
          const suberr32 = ref7.errors
          validate.errors = err32
          if (!res32) {
            validate.errors = [
              errorMerge(
                suberr32[0],
                '#/oneOf/40/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'eth_submitWork':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/41/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err33 = validate.errors
          const res33 = ref1(data.params)
          const suberr33 = ref1.errors
          validate.errors = err33
          if (!res33) {
            validate.errors = [
              errorMerge(
                suberr33[0],
                '#/oneOf/41/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'personal_sign':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/42/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err34 = validate.errors
          const res34 = ref10(data.params)
          const suberr34 = ref10.errors
          validate.errors = err34
          if (!res34) {
            validate.errors = [
              errorMerge(
                suberr34[0],
                '#/oneOf/42/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'net_version':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/43/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/43/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'wallet_getPermissions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/44/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/44/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'wallet_requestPermissions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/45/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err37 = validate.errors
          const res37 = ref11(data.params)
          const suberr37 = ref11.errors
          validate.errors = err37
          if (!res37) {
            validate.errors = [
              errorMerge(
                suberr37[0],
                '#/oneOf/45/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'wallet_revokePermissions':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/46/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err38 = validate.errors
          const res38 = ref11(data.params)
          const suberr38 = ref11.errors
          validate.errors = err38
          if (!res38) {
            validate.errors = [
              errorMerge(
                suberr38[0],
                '#/oneOf/46/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'wallet_switchEthereumChain':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/47/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err39 = validate.errors
          const res39 = ref14(data.params)
          const suberr39 = ref14.errors
          validate.errors = err39
          if (!res39) {
            validate.errors = [
              errorMerge(
                suberr39[0],
                '#/oneOf/47/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'wallet_addEthereumChain':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/48/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err40 = validate.errors
          const res40 = ref15(data.params)
          const suberr40 = ref15.errors
          validate.errors = err40
          if (!res40) {
            validate.errors = [
              errorMerge(
                suberr40[0],
                '#/oneOf/48/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'wallet_watchAsset':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/49/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          const err43 = validate.errors
          const res43 = ref16(data.params)
          const suberr43 = ref16.errors
          validate.errors = err43
          if (!res43) {
            validate.errors = [
              errorMerge(
                suberr43[0],
                '#/oneOf/49/properties/params/$ref',
                '#/params',
              ),
            ]
            return false
          }
          break
        case 'web3_clientVersion':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/50/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/50/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        case 'wallet_getSnaps':
          if (!('params' in data && hasOwn(data, 'params'))) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/51/required',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          if (!(Array.isArray(data.params) && data.params.length === 0)) {
            validate.errors = [
              {
                keywordLocation: '#/oneOf/51/properties/params/const',
                instanceLocation: '#/params',
              },
            ]
            return false
          }
          break
        default:
          validate.errors = [
            { keywordLocation: '#/oneOf', instanceLocation: '#' },
          ]
          return false
      }
      for (const key11 of Object.keys(data)) {
        if (
          key11 !== 'id' &&
          key11 !== 'jsonrpc' &&
          key11 !== 'method' &&
          key11 !== 'params'
        ) {
          validate.errors = [
            {
              keywordLocation: '#/unevaluatedProperties',
              instanceLocation: '#/' + pointerPart(key11),
            },
          ]
          return false
        }
      }
      return true
    }
    return ref0
  })()

  const isValid = validate(value)
  if (!isValid) {
    const { keywordLocation, instanceLocation } = validate.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return value
}

export function parseAndValidateTypedData(value) {
  const parse = (function () {
    'use strict'
    const hasOwn = Function.prototype.call.bind(Object.prototype.hasOwnProperty)
    const stringLength = (string) =>
      /[\uD800-\uDFFF]/.test(string) ? [...string].length : string.length
    const pointerPart = (s) =>
      /~\//.test(s) ? `${s}`.replace(/~/g, '~0').replace(/\//g, '~1') : s
    const format0 = new RegExp('^(?![\\s_])[\\s\\w!?.,/()[\\]-]+$', '')
    const ref2 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!(data.name !== undefined && hasOwn(data, 'name'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/name' },
        ]
        return false
      }
      if (!(data.type !== undefined && hasOwn(data, 'type'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/type' },
        ]
        return false
      }
      if (!(typeof data.name === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/name/type',
            instanceLocation: '#/name',
          },
        ]
        return false
      }
      if (data.name.length > 50 && stringLength(data.name) > 50) {
        validate.errors = [
          {
            keywordLocation: '#/properties/name/maxLength',
            instanceLocation: '#/name',
          },
        ]
        return false
      }
      if (!format0.test(data.name)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/name/format',
            instanceLocation: '#/name',
          },
        ]
        return false
      }
      if (!(typeof data.type === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/type',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      if (data.type.length > 50 && stringLength(data.type) > 50) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/maxLength',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      if (!format0.test(data.type)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/type/format',
            instanceLocation: '#/type',
          },
        ]
        return false
      }
      for (const key1 of Object.keys(data)) {
        if (key1 !== 'name' && key1 !== 'type') {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key1),
            },
          ]
          return false
        }
      }
      return true
    }
    const errorMerge = (
      { keywordLocation, instanceLocation },
      schemaBase,
      dataBase,
    ) => ({
      keywordLocation: `${schemaBase}${keywordLocation.slice(1)}`,
      instanceLocation: `${dataBase}${instanceLocation.slice(1)}`,
    })
    const format1 = new RegExp(
      '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$|^[0-9](\\.[0-9]){0,1}$',
      '',
    )
    const pattern0 = new RegExp('^[0-9]+$', 'u')
    const format2 = new RegExp('^0x[0-9a-f]+$', 'i')
    const format3 = new RegExp('^(?!_)(\\n|\\r|.)*$', '')
    const format4 = new RegExp('^0x[a-f0-9]{40}$', 'i')
    const ref3 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      for (const key6 of Object.keys(data)) {
        if (key6.length > 50 && stringLength(key6) > 50) {
          validate.errors = [
            {
              keywordLocation: '#/propertyNames/maxLength',
              instanceLocation: '#/' + pointerPart(key6),
            },
          ]
          return false
        }
        if (!format0.test(key6)) {
          validate.errors = [
            {
              keywordLocation: '#/propertyNames/format',
              instanceLocation: '#/' + pointerPart(key6),
            },
          ]
          return false
        }
      }
      for (const key7 of Object.keys(data)) {
        const sub16 = (() => {
          if (
            !(
              typeof data[key7] === 'object' &&
              data[key7] &&
              !Array.isArray(data[key7]) &&
              Object.keys(data[key7]).length === 0
            )
          )
            return false
          return true
        })()
        const sub17 = (() => {
          if (!(typeof data[key7] === 'boolean')) return false
          return true
        })()
        const sub18 = (() => {
          if (!Number.isInteger(data[key7])) return false
          return true
        })()
        const sub19 = (() => {
          if (!(typeof data[key7] === 'number')) return false
          return true
        })()
        const sub20 = (() => {
          if (!(typeof data[key7] === 'string')) return false
          if (!format2.test(data[key7])) return false
          return true
        })()
        const sub21 = (() => {
          if (!(typeof data[key7] === 'string')) return false
          if (data[key7].length > 100 && stringLength(data[key7]) > 100)
            return false
          if (!format3.test(data[key7])) return false
          return true
        })()
        const sub22 = (() => {
          if (!Array.isArray(data[key7])) return false
          for (let l = 0; l < data[key7].length; l++) {
            if (data[key7][l] !== undefined && hasOwn(data[key7], l)) {
              const sub23 = (() => {
                if (!(typeof data[key7][l] === 'string')) return false
                if (!format4.test(data[key7][l])) return false
                return true
              })()
              const sub24 = (() => {
                if (!(typeof data[key7][l] === 'string')) return false
                if (!format2.test(data[key7][l])) return false
                return true
              })()
              const sub25 = (() => {
                if (!(typeof data[key7][l] === 'string')) return false
                if (
                  data[key7][l].length > 100 &&
                  stringLength(data[key7][l]) > 100
                )
                  return false
                if (!format3.test(data[key7][l])) return false
                return true
              })()
              const sub26 = (() => {
                const err2 = validate.errors
                const res2 = validate(data[key7][l])
                const suberr2 = validate.errors
                validate.errors = err2
                if (!res2) return false
                return true
              })()
              if (!(sub23 || sub24 || sub25 || sub26)) return false
            }
          }
          return true
        })()
        const sub27 = (() => {
          const err3 = validate.errors
          const res3 = validate(data[key7])
          const suberr3 = validate.errors
          validate.errors = err3
          if (!res3) return false
          return true
        })()
        if (
          !(
            sub16 ||
            sub17 ||
            sub18 ||
            sub19 ||
            sub20 ||
            sub21 ||
            sub22 ||
            sub27
          )
        ) {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties/anyOf',
              instanceLocation: '#/' + pointerPart(key7),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref1 = function validate(data) {
      validate.errors = null
      if (!(typeof data === 'object' && data && !Array.isArray(data))) {
        validate.errors = [{ keywordLocation: '#/type', instanceLocation: '#' }]
        return false
      }
      if (!(data.domain !== undefined && hasOwn(data, 'domain'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/domain' },
        ]
        return false
      }
      if (!(data.message !== undefined && hasOwn(data, 'message'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/message' },
        ]
        return false
      }
      if (!(data.primaryType !== undefined && hasOwn(data, 'primaryType'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/primaryType' },
        ]
        return false
      }
      if (!(data.types !== undefined && hasOwn(data, 'types'))) {
        validate.errors = [
          { keywordLocation: '#/required', instanceLocation: '#/types' },
        ]
        return false
      }
      if (
        !(
          typeof data.types === 'object' &&
          data.types &&
          !Array.isArray(data.types)
        )
      ) {
        validate.errors = [
          {
            keywordLocation: '#/properties/types/type',
            instanceLocation: '#/types',
          },
        ]
        return false
      }
      for (const key0 of Object.keys(data.types)) {
        if (key0.length > 50 && stringLength(key0) > 50) {
          validate.errors = [
            {
              keywordLocation: '#/properties/types/propertyNames/maxLength',
              instanceLocation: '#/types/' + pointerPart(key0),
            },
          ]
          return false
        }
        if (!format0.test(key0)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/types/propertyNames/format',
              instanceLocation: '#/types/' + pointerPart(key0),
            },
          ]
          return false
        }
      }
      if (
        !(
          data.types.EIP712Domain !== undefined &&
          hasOwn(data.types, 'EIP712Domain')
        )
      ) {
        validate.errors = [
          {
            keywordLocation: '#/properties/types/required',
            instanceLocation: '#/types/EIP712Domain',
          },
        ]
        return false
      }
      if (!Array.isArray(data.types.EIP712Domain)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/types/properties/EIP712Domain/type',
            instanceLocation: '#/types/EIP712Domain',
          },
        ]
        return false
      }
      for (let i = 0; i < data.types.EIP712Domain.length; i++) {
        if (
          data.types.EIP712Domain[i] !== undefined &&
          hasOwn(data.types.EIP712Domain, i)
        ) {
          const err0 = validate.errors
          const res0 = ref2(data.types.EIP712Domain[i])
          const suberr0 = ref2.errors
          validate.errors = err0
          if (!res0) {
            validate.errors = [
              errorMerge(
                suberr0[0],
                '#/properties/types/properties/EIP712Domain/items/$ref',
                '#/types/EIP712Domain/' + i,
              ),
            ]
            return false
          }
          if (
            !(
              typeof data.types.EIP712Domain[i] === 'object' &&
              data.types.EIP712Domain[i] &&
              !Array.isArray(data.types.EIP712Domain[i])
            )
          ) {
            validate.errors = [
              {
                keywordLocation:
                  '#/properties/types/properties/EIP712Domain/items/type',
                instanceLocation: '#/types/EIP712Domain/' + i,
              },
            ]
            return false
          }
        }
      }
      for (const key2 of Object.keys(data.types)) {
        if (key2 !== 'EIP712Domain') {
          if (!Array.isArray(data.types[key2])) {
            validate.errors = [
              {
                keywordLocation: '#/properties/types/additionalProperties/type',
                instanceLocation: '#/types/' + pointerPart(key2),
              },
            ]
            return false
          }
          for (let j = 0; j < data.types[key2].length; j++) {
            if (
              data.types[key2][j] !== undefined &&
              hasOwn(data.types[key2], j)
            ) {
              const err1 = validate.errors
              const res1 = ref2(data.types[key2][j])
              const suberr1 = ref2.errors
              validate.errors = err1
              if (!res1) {
                validate.errors = [
                  errorMerge(
                    suberr1[0],
                    '#/properties/types/additionalProperties/items/$ref',
                    '#/types/' + pointerPart(key2) + '/' + j,
                  ),
                ]
                return false
              }
            }
          }
        }
      }
      if (!(typeof data.primaryType === 'string')) {
        validate.errors = [
          {
            keywordLocation: '#/properties/primaryType/type',
            instanceLocation: '#/primaryType',
          },
        ]
        return false
      }
      if (data.primaryType.length > 50 && stringLength(data.primaryType) > 50) {
        validate.errors = [
          {
            keywordLocation: '#/properties/primaryType/maxLength',
            instanceLocation: '#/primaryType',
          },
        ]
        return false
      }
      if (!format0.test(data.primaryType)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/primaryType/format',
            instanceLocation: '#/primaryType',
          },
        ]
        return false
      }
      const sub0 = (() => {
        if (
          !(
            typeof data.domain === 'object' &&
            data.domain &&
            !Array.isArray(data.domain) &&
            Object.keys(data.domain).length === 0
          )
        )
          return false
        return true
      })()
      const sub1 = (() => {
        if (
          !(
            typeof data.domain === 'object' &&
            data.domain &&
            !Array.isArray(data.domain)
          )
        )
          return false
        if (!(data.domain.name !== undefined && hasOwn(data.domain, 'name')))
          return false
        if (!(typeof data.domain.name === 'string')) return false
        if (data.domain.name.length > 50 && stringLength(data.domain.name) > 50)
          return false
        if (!format0.test(data.domain.name)) return false
        if (
          data.domain.version !== undefined &&
          hasOwn(data.domain, 'version')
        ) {
          if (!(typeof data.domain.version === 'string')) return false
          if (
            data.domain.version.length > 255 &&
            stringLength(data.domain.version) > 255
          )
            return false
          if (!format1.test(data.domain.version)) return false
        }
        if (
          data.domain.chainId !== undefined &&
          hasOwn(data.domain, 'chainId')
        ) {
          let passes0 = 0
          const sub2 = (() => {
            if (!Number.isInteger(data.domain.chainId)) return false
            return true
          })()
          if (sub2) passes0++
          const sub3 = (() => {
            if (!(typeof data.domain.chainId === 'string')) return false
            if (!pattern0.test(data.domain.chainId)) return false
            return true
          })()
          if (sub3) passes0++
          const sub4 = (() => {
            if (!(typeof data.domain.chainId === 'string')) return false
            if (!format2.test(data.domain.chainId)) return false
            return true
          })()
          if (sub4) passes0++
          if (passes0 !== 1) return false
        }
        if (
          data.domain.verifyingContract !== undefined &&
          hasOwn(data.domain, 'verifyingContract')
        ) {
          if (!(typeof data.domain.verifyingContract === 'string')) return false
          if (!format2.test(data.domain.verifyingContract)) return false
        }
        if (data.domain.salt !== undefined && hasOwn(data.domain, 'salt')) {
          if (!(typeof data.domain.salt === 'string')) return false
          if (!format2.test(data.domain.salt)) return false
        }
        for (const key3 of Object.keys(data.domain)) {
          if (
            key3 !== 'name' &&
            key3 !== 'version' &&
            key3 !== 'chainId' &&
            key3 !== 'verifyingContract' &&
            key3 !== 'salt'
          )
            return false
        }
        return true
      })()
      if (!(sub0 || sub1)) {
        validate.errors = [
          {
            keywordLocation: '#/properties/domain/anyOf',
            instanceLocation: '#/domain',
          },
        ]
        return false
      }
      if (
        !(
          typeof data.message === 'object' &&
          data.message &&
          !Array.isArray(data.message)
        )
      ) {
        validate.errors = [
          {
            keywordLocation: '#/properties/message/type',
            instanceLocation: '#/message',
          },
        ]
        return false
      }
      for (const key4 of Object.keys(data.message)) {
        if (key4.length > 50 && stringLength(key4) > 50) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/propertyNames/maxLength',
              instanceLocation: '#/message/' + pointerPart(key4),
            },
          ]
          return false
        }
        if (!format0.test(key4)) {
          validate.errors = [
            {
              keywordLocation: '#/properties/message/propertyNames/format',
              instanceLocation: '#/message/' + pointerPart(key4),
            },
          ]
          return false
        }
      }
      for (const key5 of Object.keys(data.message)) {
        const sub5 = (() => {
          if (
            !(
              typeof data.message[key5] === 'object' &&
              data.message[key5] &&
              !Array.isArray(data.message[key5]) &&
              Object.keys(data.message[key5]).length === 0
            )
          )
            return false
          return true
        })()
        const sub6 = (() => {
          if (!(typeof data.message[key5] === 'boolean')) return false
          return true
        })()
        const sub7 = (() => {
          if (!Number.isInteger(data.message[key5])) return false
          return true
        })()
        const sub8 = (() => {
          if (!(typeof data.message[key5] === 'number')) return false
          return true
        })()
        const sub9 = (() => {
          if (!(typeof data.message[key5] === 'string')) return false
          if (!format2.test(data.message[key5])) return false
          return true
        })()
        const sub10 = (() => {
          if (!(typeof data.message[key5] === 'string')) return false
          if (
            data.message[key5].length > 100 &&
            stringLength(data.message[key5]) > 100
          )
            return false
          if (!format3.test(data.message[key5])) return false
          return true
        })()
        const sub11 = (() => {
          if (!Array.isArray(data.message[key5])) return false
          for (let k = 0; k < data.message[key5].length; k++) {
            if (
              data.message[key5][k] !== undefined &&
              hasOwn(data.message[key5], k)
            ) {
              const sub12 = (() => {
                if (!(typeof data.message[key5][k] === 'string')) return false
                if (!format4.test(data.message[key5][k])) return false
                return true
              })()
              const sub13 = (() => {
                if (!(typeof data.message[key5][k] === 'string')) return false
                if (!format2.test(data.message[key5][k])) return false
                return true
              })()
              const sub14 = (() => {
                if (!(typeof data.message[key5][k] === 'string')) return false
                if (
                  data.message[key5][k].length > 100 &&
                  stringLength(data.message[key5][k]) > 100
                )
                  return false
                if (!format3.test(data.message[key5][k])) return false
                return true
              })()
              const sub15 = (() => {
                const err4 = validate.errors
                const res4 = ref3(data.message[key5][k])
                const suberr4 = ref3.errors
                validate.errors = err4
                if (!res4) return false
                return true
              })()
              if (!(sub12 || sub13 || sub14 || sub15)) return false
            }
          }
          return true
        })()
        const sub28 = (() => {
          const err5 = validate.errors
          const res5 = ref3(data.message[key5])
          const suberr5 = ref3.errors
          validate.errors = err5
          if (!res5) return false
          return true
        })()
        if (
          !(sub5 || sub6 || sub7 || sub8 || sub9 || sub10 || sub11 || sub28)
        ) {
          validate.errors = [
            {
              keywordLocation:
                '#/properties/message/additionalProperties/anyOf',
              instanceLocation: '#/message/' + pointerPart(key5),
            },
          ]
          return false
        }
      }
      for (const key8 of Object.keys(data)) {
        if (
          key8 !== 'types' &&
          key8 !== 'primaryType' &&
          key8 !== 'domain' &&
          key8 !== 'message'
        ) {
          validate.errors = [
            {
              keywordLocation: '#/additionalProperties',
              instanceLocation: '#/' + pointerPart(key8),
            },
          ]
          return false
        }
      }
      return true
    }
    const ref0 = function validate(data) {
      validate.errors = null
      const err6 = validate.errors
      const res6 = ref1(data)
      const suberr6 = ref1.errors
      validate.errors = err6
      if (!res6) {
        validate.errors = [errorMerge(suberr6[0], '#/$ref', '#')]
        return false
      }
      return true
    }
    const parseWrap = (validate) => (src) => {
      if (typeof src !== 'string')
        return { valid: false, error: 'Input is not a string' }
      try {
        const value = JSON.parse(src)
        if (!validate(value)) {
          const { keywordLocation, instanceLocation } = validate.errors[0]
          const keyword = keywordLocation.slice(
            keywordLocation.lastIndexOf('/') + 1,
          )
          const error = `JSON validation failed for ${keyword} at ${instanceLocation}`
          return { valid: false, error, errors: validate.errors }
        }
        return { valid: true, value }
      } catch ({ message }) {
        return { valid: false, error: message }
      }
    }
    return parseWrap(ref0)
  })()

  const parsedObject = parse(value)
  if (!parsedObject.valid) {
    const { keywordLocation, instanceLocation } = parsedObject.errors[0]
    const keyword = keywordLocation.slice(keywordLocation.lastIndexOf('/') + 1)
    const message = `JSON validation failed for ${keyword} at ${instanceLocation}`
    // TODO: Throw custom error (maybe -32700 from EIP-1474).
    throw new Error(message)
  }

  return parsedObject.value
}
